(function () {
  'use strict';
  const config = window.BuilderBrandPresentationConfig;
  if (!config || !Array.isArray(config.rules)) return;
  const byPath = new Map();
  for (const rule of config.rules) for (const path of rule.aliases) byPath.set(path, rule);
  const attached = new WeakMap();
  const seen = new Set();
  let queued = false;
  function path(value) {
    try { return new URL(value, location.href).pathname; } catch (_) { return ''; }
  }
  function fromImage(img) {
    // currentSrc first: a lazy URL can be present while another raster is visible.
    if (img.currentSrc && img.complete && img.naturalWidth > 4) return byPath.get(path(img.currentSrc)) || null;
    const values = [img.currentSrc, img.src, img.getAttribute('data-src'), img.getAttribute('data-original')];
    for (const value of values) {
      const rule = byPath.get(path(value));
      if (rule) return rule;
    }
    const set = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    for (const candidate of set.split(',')) {
      const rule = byPath.get(path(candidate.trim().split(/\s+/)[0]));
      if (rule) return rule;
    }
    return null;
  }
  function build(rule) {
    const host = document.createElement('span');
    host.className = 'bbp-overlay';
    host.dataset.bbpOwned = '1';
    host.dataset.bbpKey = rule.key;
    host.setAttribute('aria-hidden', 'true');
    if (rule.action === 'gift-html') {
      const card = document.createElement('span');
      card.className = 'bbp-gift';
      for (const [cls, text] of [['bbp-gift-brand', 'Zanverio'], ['bbp-gift-title', 'Bono regalo'], ['bbp-gift-text', 'Una oferta especial para tu próxima compra.']]) {
        const line = document.createElement('span'); line.className = cls; line.textContent = text; card.appendChild(line);
      }
      host.appendChild(card);
    } else {
      for (const region of rule.regions) {
        const label = document.createElement('span'); label.className = 'bbp-label'; label.textContent = region.text;
        Object.assign(label.style, {left: region.x * 100 + '%', top: region.y * 100 + '%', width: region.w * 100 + '%', height: region.h * 100 + '%', background: region.background, color: region.color, fontWeight: region.fontWeight});
        host.appendChild(label);
      }
      if (rule.originCaption) {
        const origin = document.createElement('span'); origin.className = 'bbp-origin'; origin.textContent = rule.originCaption; host.appendChild(origin);
      }
    }
    return host;
  }
  function parentOf(img) {
    // A span must not be inserted inside <picture>; use its container.
    let parent = img.parentElement;
    if (parent && parent.tagName === 'PICTURE') parent = parent.parentElement;
    return parent;
  }
  function cleanup(img) {
    const record = attached.get(img);
    if (record) { record.host.remove(); attached.delete(img); }
  }
  function fit(record) {
    const {img, parent, host, rule} = record;
    if (!img.isConnected || !parent.isConnected) { cleanup(img); seen.delete(img); return; }
    const ir = img.getBoundingClientRect(), pr = parent.getBoundingClientRect();
    if (!ir.width || !ir.height) { host.style.display = 'none'; return; }
    host.style.display = 'block';
    let width = ir.width, height = ir.height, dx = 0, dy = 0;
    const style = getComputedStyle(img);
    const croppedCover = style.objectFit === 'cover' && img.naturalWidth && img.naturalHeight && Math.abs(width / height - img.naturalWidth / img.naturalHeight) > .01;
    if (croppedCover || (style.objectFit === 'contain' && style.objectPosition !== '50% 50%')) {
      host.style.display = 'none'; img.dataset.bbpPendingFit = rule.key; return;
    }
    delete img.dataset.bbpPendingFit;
    if (style.objectFit === 'contain' && img.naturalWidth && img.naturalHeight) {
      const ratio = Math.min(width / img.naturalWidth, height / img.naturalHeight);
      const nw = img.naturalWidth * ratio, nh = img.naturalHeight * ratio;
      // Centered contain is the native gallery default. Non-centered needs QA.
      dx = (width - nw) / 2; dy = (height - nh) / 2; width = nw; height = nh;
    }
    Object.assign(host.style, {left: ir.left - pr.left - parent.clientLeft + parent.scrollLeft + dx + 'px', top: ir.top - pr.top - parent.clientTop + parent.scrollTop + dy + 'px', width: width + 'px', height: height + 'px'});
    const labels = host.querySelectorAll('.bbp-label');
    labels.forEach((label, i) => {
      const r = rule.regions[i];
      const regionWidth = width * r.w, regionHeight = height * r.h;
      let size = Math.min(regionHeight * .66, regionWidth / Math.max(1, r.text.length) * 1.72);
      label.style.fontSize = Math.max(3, size) + 'px';
      if (label.scrollWidth > label.clientWidth && label.clientWidth) label.style.fontSize = Math.max(3, size * label.clientWidth / label.scrollWidth) + 'px';
    });
  }
  function inspect(img) {
    if (img.closest('[data-bbp-owned]')) return;
    const rule = fromImage(img), previous = attached.get(img);
    if (!rule || !rule.enabled || rule.action === 'decision-exclude') {
      cleanup(img);
      if (rule && rule.action === 'decision-exclude') {
        // Deliberately no photo hiding: root must choose clean same-SKU media,
        // then hide its slide AND navigation together, with carousel QA.
        img.dataset.bbpPendingKey = rule.key;
      } else delete img.dataset.bbpPendingKey;
      return;
    }
    delete img.dataset.bbpPendingKey;
    if (previous && previous.rule.key === rule.key) { fit(previous); return; }
    cleanup(img);
    const parent = parentOf(img); if (!parent) return;
    if (getComputedStyle(parent).position === 'static') parent.classList.add('bbp-parent');
    const host = build(rule), record = {img, parent, host, rule};
    parent.appendChild(host); attached.set(img, record); seen.add(img); fit(record);
    if (rule.action === 'gift-html') img.alt = 'Zanverio — Bono regalo';
    if (resize) { resize.observe(img); resize.observe(parent); }
  }
  function scan() {
    queued = false;
    document.querySelectorAll('img').forEach(inspect);
    for (const img of seen) { const record = attached.get(img); if (record) fit(record); else seen.delete(img); }
    // Report background matches explicitly. Arbitrary background positions/
    // sizes cannot safely use pixel coordinates without per-element QA.
    document.querySelectorAll('[style*="background"]').forEach(element => {
      if (element.closest('[data-bbp-owned]')) return;
      const css = element.style.backgroundImage || '';
      for (const match of css.matchAll(/url\(["']?([^"')]+)["']?\)/g)) {
        const rule = byPath.get(path(match[1]));
        if (rule) element.dataset.bbpPendingBackgroundKey = rule.key;
      }
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(scan); } }
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const observer = new MutationObserver(records => {
    if (records.some(record => !record.target.closest || !record.target.closest('[data-bbp-owned]'))) schedule();
  });
  observer.observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['src','srcset','data-src','data-srcset','data-original','class','hidden']});
  document.addEventListener('load', event => { if (event.target.tagName === 'IMG') schedule(); }, true);
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('orientationchange', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  window.BuilderBrandPresentation = {scan, rules:config.rules, pending:function () { return Array.from(document.querySelectorAll('[data-bbp-pending-key],[data-bbp-pending-background-key],[data-bbp-pending-fit]')).map(e => ({key:e.dataset.bbpPendingKey || e.dataset.bbpPendingBackgroundKey || e.dataset.bbpPendingFit, tag:e.tagName})); }};
  schedule();
})();
